<template>
  <div class="course-create-wrap">
    <a-form :form="form">
      <a-card :bordered="false" style="box-shadow:0px 1px 10px 0px rgba(0,0,0,0.06);">
        <div class="info-title">编辑题目</div>
        <div class="info-content" style="padding-top:25px;padding-bottom:30px;">
          <a-row>
            <a-col :span="24">
              <a-form-item
                style="margin-bottom:12px;"
                :label-col="{ span: 2 }"
                :wrapper-col=" { span: 14 }"
                label="题型"
              >
                <!-- <a-select
                  v-model="topicType"
                  placeholder="请选择题目类型"
                  v-decorator="[
                    'type',
                    {rules: [{ required: true, message: '请选择题目类型' }]},
                  ]"
                > -->
                <j-dict-select-tag v-model="type" placeholder="请选择题目类型" dictCode="exercise_type" />
                <!-- <a-select-option :value="item.type" v0>
                    {{ item.name }}
                  </a-select-option> -->
                <!-- </a-select> -->
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="24">
              <a-form-item
                style="margin-bottom:12px;"
                :label-col="{ span: 2 }"
                :wrapper-col="{ span: 14 }"
                label="题干   ">
                <!-- 阿斯顿撒多 -->
                <j-editor v-model="exerciseInfo.stem"></j-editor>
                <!-- <j-editor
                  v-decorator="[ 'stem', {} ,{}]"
                  triggerChange></j-editor> -->
              </a-form-item>
            </a-col>
          </a-row>
          <!-- 数学 & 逻辑 -->
          <div class="" v-if="type==1||type==2||type==3">
            <a-row>
              <a-col :span="24">
                <a-form-item
                  style="margin-bottom:12px;"
                  :label-col="{ span: 2 }"
                  :wrapper-col=" { span: 14 }"
                  label="选项"
                >
                  <div class="j-teacher-add" style="margin-top:4px;margin-bottom:10px;">
                    <a-button
                      style="color:rgb(208, 219, 228);text-align:center;text-shadow:none;width:100%;line-height:34px;height:34px;font-size:14px;background-color:#F4F5F7;border-color:#D0DBE4"
                      type="primary"
                      icon="plus"
                      @click="addOption"
                    > 新增选项
                    </a-button>
                  </div>
                  <div class="" >
                    <a-row >
                      <a-col :span="24">
                        <a-form-item
                          style="margin-bottom:12px;"
                          :wrapper-col="{ span: 24 }"
                          label="">
                          <a-radio-group v-model="rightValue" style="width:100%">
                            <div class="item-options" v-for="(data,index) in optionList" :key="index">
                              <div class="item-name">{{ data.optionSign }}</div>
                              <j-editor v-model="data.optionText" :config="myConfig"></j-editor>
                              <!-- <a-textarea
                                class="item-form"
                                style="height:80px;resize: none;margin-bottom: 0px;"
                                placeholder="请输入答案"
                                v-model="data.optionText"
                                /> -->
                              <div class="right-item">
                                <a-radio :value="data.optionSign"></a-radio>
                              </div>
                              <div class="item-remove">
                                <a-icon type="delete" style="color:#f5222d" @click="deleteOption(index)"/>
                              </div>
                            </div>
                            <!-- <div class="item-options">
                              <div class="item-name">B</div>
                              <a-textarea
                                class="item-form"
                                style="height:80px;resize: none;margin-bottom: 0px;"
                                placeholder="请输入答案"
                                v-decorator="[
                                  'answer[1]',
                                  {rules: [{ required: true, message: '请输入答案' }]},
                                  {}
                                ]" />
                              <div class="right-item">
                                <a-radio value="B"></a-radio>
                              </div>
                              <div class="item-remove">
                                <a-icon type="delete" style="color:#f5222d"/>
                              </div>
                            </div> -->
                          </a-radio-group>
                        </a-form-item>
                      </a-col>
                    </a-row>
                  </div>
                </a-form-item>
              </a-col>
            </a-row>
          </div>
          <!-- 阅读理解 & 完型填空 -->
          <div class="" v-if="type==6||type==7||type==8">
            <a-row>
              <a-col :span="24">
                <a-form-item
                  style="margin-bottom:12px;"
                  :label-col="{ span: 2 }"
                  :wrapper-col=" { span: 14 }"
                  label="选项"
                >
                  <div class="j-teacher-add" style="margin-top:4px;margin-bottom:10px;">
                    <a-button
                      style="color:rgb(208, 219, 228);text-align:center;text-shadow:none;width:100%;line-height:34px;height:34px;font-size:14px;background-color:#F4F5F7;border-color:#D0DBE4"
                      type="primary"
                      icon="plus"
                      @click="addSubExercise()"
                    > 新增题目
                    </a-button>
                  </div>
                  <div class="" >
                    <a-row >
                      <a-col :span="24">
                        <a-form-item
                          style="margin-bottom:12px;"
                          :wrapper-col="{ span: 24 }"
                          label="">
                          <a-table
                            ref="table"
                            size="middle"
                            rowKey="id"
                            :columns="columns"
                            :dataSource="children"
                            :pagination="ipagination">
                            <span slot="tigan" slot-scope="text, record,index" >
                              <a @click="topicChildEdite(record,index)"><p v-html="text"></p></a>
                            </span>
                          </a-table>
                        </a-form-item>
                      </a-col>
                    </a-row>
                  </div>
                </a-form-item>
              </a-col>
            </a-row>
          </div>
          <div v-if="type!=6&&type!=7&&type!=8">
            <a-row>
              <a-col :span="24">
                <a-form-item
                  style="margin-bottom:12px;"
                  :label-col="{ span: 2 }"
                  :wrapper-col=" { span: 14 }"
                  label="题目分值"
                >
                  <a-input
                    placeholder="请输入题目分值"
                    v-decorator="[
                      'score',
                      {rules: [{ required: true, message: '请输入题目分值' }]},
                    ]"
                  />
                </a-form-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="24">
                <a-form-item
                  style="margin-bottom:12px;"
                  :label-col="{ span: 2 }"
                  :wrapper-col=" { span: 14 }"
                  label="题目出自"
                >
                  <a-input
                    placeholder="请输入题目出自"
                    v-decorator="[
                      'exerciseSrc',
                      {rules: [{ required: true, message: '请输入题目出自' }]},
                    ]"
                  />
                </a-form-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="24">
                <a-form-item
                  style="margin-bottom:12px;"
                  :label-col="{ span: 2 }"
                  :wrapper-col=" { span: 14 }"
                  label="知识点"
                >
                  <a-input
                    placeholder="请输入知识点"
                    v-decorator="[
                      'knowledgePoints',
                      {rules: [{ required: true, message: '请输入知识点自' }]},
                    ]"
                  />
                </a-form-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="24">
                <a-form-item
                  style="margin-bottom:12px;"
                  :label-col="{ span: 2 }"
                  :wrapper-col="{ span: 8 }"
                  label="解析视频   "
                >
                  <div class>
                    <div class="clearfix">
                      <j-video-upload
                        v-model="analyseObj"
                        @change="uploadAfter"></j-video-upload>
                      <div style="position: absolute;left:157px;top: 22px;" v-if="downloadData.url">
                        <vue-qr
                          :text="downloadData.url"
                          :margin="0"
                          colorDark="#000"
                          colorLight="#fff"
                          :size="80"></vue-qr>
                      </div>
                    </div>
                  </div>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="24">
                <a-form-item
                  style="margin-bottom:12px;"
                  :label-col="{ span: 2 }"
                  :wrapper-col="{ span: 14 }"
                  label="解析说明   ">
                  <j-editor v-model="exerciseInfo.analyseDesc"></j-editor>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="24">
                <a-form-item
                  style="margin-bottom:12px;"
                  :label-col="{ span: 2 }"
                  :wrapper-col="{ span: 14 }"
                  label="导入序号 ">
                   <a-input
                    placeholder="请输入导入序号"
                    v-decorator="[
                      'importNo',
                      {rules: [{ required: true, message: '请输入导入序号' }]},
                    ]"
                  />
                </a-form-item>
              </a-col>
            </a-row>
          </div>
        </div>
      </a-card>
      <a-card
        :bordered="false"
        style="text-align:center;padding:14px 0px;box-shadow:0px 1px 10px 0px rgba(0,0,0,0.06);"
      >
        <div class="a-row">
          <a-button
            style="text-align:center;width:232px;line-height:40px;height:40px;font-size:14px;"
            type="primary"
            @click="videoCreateOk()"
          >保存</a-button>
        </div>
      </a-card>
    </a-form>
    <child-topic-create-modal ref="childTopicCreateModal" @ok="editChildren"></child-topic-create-modal>
  </div>
</template>

<script>

  import Vue from 'vue'
  import { ACCESS_TOKEN, TENANT_ID } from '@/store/mutation-types'
  import vueQr from 'vue-qr'

  import { exerciseAdd, getExerciseById, exerciseEdit } from '@/api/api'

  import JVideoUpload from '@/components/jeecg/JVideoUpload'
  // import VueUeditorWrap from 'vue-ueditor-wrap'

  import pick from 'lodash.pick'
  import _ from 'lodash'
  import JEditor from '@/components/jeecg/JEditor'
  import ChildTopicCreateModal from './modules/ChildTopicCreateModal'
  export default {
    name: 'TopicCreate',
    components: { JEditor, ChildTopicCreateModal, JVideoUpload, vueQr },
    mixins: [],
    data() {
      return {
        rightValue: '',
        type: '0',
        videoFullloading: false,
        videoFull: {
          id: ''
        },
        downloadData: {
          url: '',
          icon: window._CONFIG['domianURLHttp'] + '/schoolLogo.png'
        },
        headers: {},
        msg: '<h2><img src="http://img.baidu.com/hi/jx2/j_0003.gif"/>Vue + UEditor + v-model双向绑定</h2>',
        isFrom: '',
        form: this.$form.createForm(this),
        loading: false,
        url: {
          fileUpload: window._CONFIG['domianURL'] + '/sys/common/upload',
          videoUpload: window._CONFIG['domianURL'] + '/sys/common/aliyunVodUpload'
        },
        ipagination: false,
        optionSign: ['A', 'B', 'C', 'D', 'E', 'F', 'G'],
        dataSource: [
          // {
          //   tigan: '01',
          //   fenzhi: '5',
          //   zhishidian: '我就是知识点',
          //   chuzi: '202001卷'
          // }
        ],
        myConfig: {
          initialFrameHeight: 80
        },
        columns: [
          {
            title: '题干',
            align: 'center',
            dataIndex: 'stem',
            width: 200,
            scopedSlots: { customRender: 'tigan' }
          },
          {
            title: '分值',
            align: 'center',
            dataIndex: 'score',
            width: 100
          },
          {
            title: '知识点',
            align: 'center',
            dataIndex: 'knowledgePoints',
            width: 200
          },
          {
            title: '题目出自',
            align: 'center',
            dataIndex: 'exerciseSrc',
            width: 200
          }
        ],
        optionList: [],
        children: [],
        exerciseInfo: {},
        analyseObj: {}
        // myConfig: {
        //   // 编辑器不自动被内容撑高
        //   autoHeightEnabled: false,
        //   // 初始容器高度
        //   initialFrameHeight: 240,
        //   // 初始容器宽度
        //   initialFrameWidth: '100%',
        //   // 上传文件接口（这个地址是我为了方便各位体验文件上传功能搭建的临时接口，请勿在生产环境使用！！！）
        //  // serverUrl: "http://localhost:8580/elinkx/config",
        //   // UEditor 资源文件的存放路径，如果你使用的是 vue-cli 生成的项目，通常不需要设置该选项，vue-ueditor-wrap 会自动处理常见的情况，如果需要特殊配置，参考下方的常见问题2
        //   UEDITOR_HOME_URL: '/static/UEditor/'
        // }
      }
    },

    methods: {
      uploadAfter (url) {
        // window._CONFIG['domianURLHttp'] +
        this.downloadData.url = 'https://www.mba-kaoyan.com/mobile/index.html#/videoView?videoId=' + url.obsObjectKey
      },
      editChildren(children, index) {
        this.children.splice(index, 1, children)
        console.log(children)
        console.log(this.children)
      },
      // 编辑字题目
      topicChildEdite(children, index) {
        this.$refs.childTopicCreateModal.open(children, index)
      },
      deleteOption(index) {
        this.optionList.splice(index, 1)
      },
      addOption() {
        if (this.optionList.length >= 7) {
          this.$message.warning('最多7个选项！')
        } else {
          var option = {
            exerciseId: this.id,
            isRight: 0,
            optionSign: this.optionSign[this.optionList.length],
            optionText: ''
          }
          this.optionList.push(option)
        }
      },
      // 保存
      videoCreateOk() {
        // this.$message.warning(this.msg);
        // return;
        this.form.validateFields((err, values) => {
          if (!err) {
            // let courseId = this.courseId
            // let chapterId = this.chapterId
            // let id = this.id

            let valuesParam = {}
            valuesParam = { ...values }
            if (this.optionList) {
              this.optionList.forEach(element => {
                if (element.optionSign == this.rightValue) {
                  element.isRight = 1
                } else {
                  element.isRight = 0
                }
              })

            // valuesParam['optionList'] = this.optionList;
            this.exerciseInfo.optionList = this.optionList
            } else {
              // valuesParam['children'] = this.children;
              this.exerciseInfo.children = this.children
            }

            console.log(this.exerciseInfo.children)

            // 格式化题干
            if(this.exerciseInfo.children){
              this.exerciseInfo.children.map((item)=>{
                item.stem = item.stem.replaceAll('&nbsp;',' ');
                if(item.optionList){
                  item.optionList.map((sitem)=>{
                    sitem.optionText = sitem.optionText.replaceAll('&nbsp;',' ');
                  })
                }
              })
            }
            

            console.log('--------')
            console.log(this.exerciseInfo.children)

            // valuesParam['analyseUrl'] = this.analyseUrl.id;
            this.exerciseInfo.analyseUrl = this.analyseObj.obsObjectKey
            this.exerciseInfo.analyseName = this.analyseObj.obsName
            // valuesParam['type'] = this.type;
            this.exerciseInfo.type = this.type
            this.exerciseInfo.stem = this.exerciseInfo.stem.replaceAll('&nbsp;',' ');
            this.exerciseInfo.directions = valuesParam['directions']
            this.exerciseInfo.score = valuesParam['score']
            this.exerciseInfo.knowledgePoints = valuesParam['knowledgePoints']
            // this.exerciseInfo.analyseDesc = valuesParam['analyseDesc'];
            this.exerciseInfo.exerciseSrc = valuesParam['exerciseSrc']
            this.exerciseInfo.importNo = valuesParam['importNo']
            // if (this.isFrom === 'addExercise') {
            //   valuesParam['chClass'] = 'e'
            // }
            let opFun = ''
            if (_.isEmpty(this.id)) {
              opFun = exerciseAdd(this.exerciseInfo)
            } else {
              // valuesParam = { ...valuesParam, id }
              opFun = exerciseEdit(this.exerciseInfo)
            }

            opFun.then((res) => {
              if (res.success) {
                this.$message.success(res.message, () => {
                  // this.$router.push({ path: '/exercise/topicList?id=' + this.id })
                  this.$router.push({ path: '/exerciseManage/topicList' })
                })
              } else {
                this.$message.warning(res.message)
              }
            }).finally(() => {
              // that.confirmLoading = false;
              // that.checkedDepartNames = [];
              // that.userDepartModel.departIdList = {userId:'',departIdList:[]};

              // that.close();
            })
          }
        })
      }

    },

    created () {
      const token = Vue.ls.get(ACCESS_TOKEN)
      let tenantid = Vue.ls.get(TENANT_ID)

      this.headers = { 'X-Access-Token': token, 'tenant_id': tenantid }

      // this.courseId = this.$route.query.courseId
      // this.chapterId = this.$route.query.chapterId
      // this.isFrom = this.$route.query.isFrom
      this.id = this.$route.query.id

      if (!_.isEmpty(this.id)) {
        getExerciseById({ id: this.id }).then((res) => {
          if (res.code === 0) {
            console.log(res)
            let resultData = res.result
            this.exerciseInfo = resultData
            this.$nextTick(() => {
              this.form.setFieldsValue(pick(resultData, 'type', 'stem', 'directions', 'score', 'knowledgePoints', 'analyseDesc', 'exerciseSrc','importNo'))
            })
            this.type = resultData.type

            if (resultData.optionList) {
              this.optionList = resultData.optionList
              this.optionList.forEach(element => {
                if (element.isRight == 1) {
                  this.rightValue = element.optionSign
                }
              })
            } else {
              this.children = resultData.children
            }

            // this.analyseUrl = resultData.analyseUrl ? resultData.analyseUrl : { id: '' }
            this.analyseObj = {
              obsObjectKey: resultData.analyseUrl || '',
              obsName: resultData.analyseName || ''
            }
            if (resultData.analyseUrl) {
              this.downloadData.url = 'https://www.mba-kaoyan.com/mobile/index.html#/videoView?videoId=' + resultData.analyseUrl
            }
          } else {
            this.$message.warning(res.message)
          }
        }).finally(() => {
        })
      }
    },
    computed: {
      uploadAction: function () {
        return this.url.fileUpload
      },
      videoUploadAction: function () {
        return this.url.videoUpload
      }
    }
  }
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>
<style lang="scss" scoped >
.course-create-wrap {
  .info-title {
    border-bottom: 1px solid #e7ecef;
    line-height: 50px;
    height: 50px;
    padding-left: 25px;
  }

  .info-content {
    .img-tip {
      color: #999999;
      font-size: 12px;
    }
  }
  .item-options{
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    &:last-child{
      margin-bottom: 0px;
    }
    .item-name{
      padding-right: 10px;
    }
    .item-form{
      flex: 1;
    }
    .right-item{
      padding: 0px 6px;
      margin-left: 10px;
    }
    .item-remove{
      padding: 0px 6px;
      margin-right: 10px;
      cursor: pointer;
    }
  }
}
</style>
